
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MicrosoftSubscriptionModel } from 'models/generated/Distribution.Api.Models.MicrosoftSubscription';


const _distribution_SubscriptionExportControllerHelper = new Map<string, Object>();
_distribution_SubscriptionExportControllerHelper.set('UpdateSubscription', MicrosoftSubscriptionModel);


export const distribution_SubscriptionExportControllerHelper = _distribution_SubscriptionExportControllerHelper;

